/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicLogoutRouteImport } from './routes/_public/logout'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as DashboardSettingsRouteImport } from './routes/_dashboard/settings'
import { Route as DashboardSequencesRouteImport } from './routes/_dashboard/sequences'
import { Route as DashboardContactsRouteImport } from './routes/_dashboard/contacts'
import { Route as OauthCallbackProviderRouteImport } from './routes/oauth/callback/$provider'
import { Route as DashboardSettingsSequencesRouteImport } from './routes/_dashboard/settings/sequences'
import { Route as DashboardSettingsIntegrationsRouteImport } from './routes/_dashboard/settings/integrations'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLogoutRoute = PublicLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSequencesRoute = DashboardSequencesRouteImport.update({
  id: '/sequences',
  path: '/sequences',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardContactsRoute = DashboardContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => DashboardRoute,
} as any)
const OauthCallbackProviderRoute = OauthCallbackProviderRouteImport.update({
  id: '/oauth/callback/$provider',
  path: '/oauth/callback/$provider',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardSettingsSequencesRoute =
  DashboardSettingsSequencesRouteImport.update({
    id: '/sequences',
    path: '/sequences',
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsIntegrationsRoute =
  DashboardSettingsIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => DashboardSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/contacts': typeof DashboardContactsRoute
  '/sequences': typeof DashboardSequencesRoute
  '/settings': typeof DashboardSettingsRouteWithChildren
  '/login': typeof PublicLoginRoute
  '/logout': typeof PublicLogoutRoute
  '/settings/integrations': typeof DashboardSettingsIntegrationsRoute
  '/settings/sequences': typeof DashboardSettingsSequencesRoute
  '/oauth/callback/$provider': typeof OauthCallbackProviderRoute
}
export interface FileRoutesByTo {
  '/': typeof PublicIndexRoute
  '/contacts': typeof DashboardContactsRoute
  '/sequences': typeof DashboardSequencesRoute
  '/settings': typeof DashboardSettingsRouteWithChildren
  '/login': typeof PublicLoginRoute
  '/logout': typeof PublicLogoutRoute
  '/settings/integrations': typeof DashboardSettingsIntegrationsRoute
  '/settings/sequences': typeof DashboardSettingsSequencesRoute
  '/oauth/callback/$provider': typeof OauthCallbackProviderRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_dashboard/contacts': typeof DashboardContactsRoute
  '/_dashboard/sequences': typeof DashboardSequencesRoute
  '/_dashboard/settings': typeof DashboardSettingsRouteWithChildren
  '/_public/login': typeof PublicLoginRoute
  '/_public/logout': typeof PublicLogoutRoute
  '/_public/': typeof PublicIndexRoute
  '/_dashboard/settings/integrations': typeof DashboardSettingsIntegrationsRoute
  '/_dashboard/settings/sequences': typeof DashboardSettingsSequencesRoute
  '/oauth/callback/$provider': typeof OauthCallbackProviderRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contacts'
    | '/sequences'
    | '/settings'
    | '/login'
    | '/logout'
    | '/settings/integrations'
    | '/settings/sequences'
    | '/oauth/callback/$provider'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contacts'
    | '/sequences'
    | '/settings'
    | '/login'
    | '/logout'
    | '/settings/integrations'
    | '/settings/sequences'
    | '/oauth/callback/$provider'
  id:
    | '__root__'
    | '/_dashboard'
    | '/_public'
    | '/_dashboard/contacts'
    | '/_dashboard/sequences'
    | '/_dashboard/settings'
    | '/_public/login'
    | '/_public/logout'
    | '/_public/'
    | '/_dashboard/settings/integrations'
    | '/_dashboard/settings/sequences'
    | '/oauth/callback/$provider'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRoute: typeof DashboardRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  OauthCallbackProviderRoute: typeof OauthCallbackProviderRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/logout': {
      id: '/_public/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof PublicLogoutRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/sequences': {
      id: '/_dashboard/sequences'
      path: '/sequences'
      fullPath: '/sequences'
      preLoaderRoute: typeof DashboardSequencesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/contacts': {
      id: '/_dashboard/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof DashboardContactsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/oauth/callback/$provider': {
      id: '/oauth/callback/$provider'
      path: '/oauth/callback/$provider'
      fullPath: '/oauth/callback/$provider'
      preLoaderRoute: typeof OauthCallbackProviderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/settings/sequences': {
      id: '/_dashboard/settings/sequences'
      path: '/sequences'
      fullPath: '/settings/sequences'
      preLoaderRoute: typeof DashboardSettingsSequencesRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/integrations': {
      id: '/_dashboard/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof DashboardSettingsIntegrationsRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
  }
}

interface DashboardSettingsRouteChildren {
  DashboardSettingsIntegrationsRoute: typeof DashboardSettingsIntegrationsRoute
  DashboardSettingsSequencesRoute: typeof DashboardSettingsSequencesRoute
}

const DashboardSettingsRouteChildren: DashboardSettingsRouteChildren = {
  DashboardSettingsIntegrationsRoute: DashboardSettingsIntegrationsRoute,
  DashboardSettingsSequencesRoute: DashboardSettingsSequencesRoute,
}

const DashboardSettingsRouteWithChildren =
  DashboardSettingsRoute._addFileChildren(DashboardSettingsRouteChildren)

interface DashboardRouteChildren {
  DashboardContactsRoute: typeof DashboardContactsRoute
  DashboardSequencesRoute: typeof DashboardSequencesRoute
  DashboardSettingsRoute: typeof DashboardSettingsRouteWithChildren
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardContactsRoute: DashboardContactsRoute,
  DashboardSequencesRoute: DashboardSequencesRoute,
  DashboardSettingsRoute: DashboardSettingsRouteWithChildren,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicLogoutRoute: typeof PublicLogoutRoute
  PublicIndexRoute: typeof PublicIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicLogoutRoute: PublicLogoutRoute,
  PublicIndexRoute: PublicIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  DashboardRoute: DashboardRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  OauthCallbackProviderRoute: OauthCallbackProviderRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
